const actions = {
  setBehaviors: async function ({state, commit}, {clientId, protocolId,antecedentId, behaviorId, perPage, page, startDate, endDate, sort, search}) {
    try {
      commit('setIsLoaded', false)

      let response = await state.apiManager.findByClientId(clientId, protocolId,antecedentId, behaviorId, perPage, page, startDate, endDate, sort, search)
      let data = response.data.data

      commit('setBehaviors', data.items)
      commit('setPaginate', data)
      commit('setIsLoaded', true)
    } catch (e) {
      console.error(e)
    }
  },


  setGroupedBehaviors: async function ({state, commit}, {clientId, perPage, page, startDate, endDate, frequencyType}) {
    try {
      commit('setIsLoaded', false)

      let response = await state.apiManager.findByClientIdGroupedByFrequency(clientId, perPage, page, startDate, endDate, frequencyType)
      let data = response.data.data

      commit('setBehaviors', data.items)
      commit('setPaginate', data)
      commit('setIsLoaded', true)
    } catch (e) {
      console.error(e)
    }
  },

  setTypesBehaviors: async function ({state, commit}, clientId) {
    try {
      let response = await state.apiManager.getTypes(clientId)
      let data = response.data.data

      commit('setTypesBehaviors', data)
    } catch (e) {
      console.error(e)
    }
  },
  setCurrentPage({commit}, page) {
    commit('setCurrentPage', page);
  },
  setIsAdded({commit}, isAdded) {
    commit('setIsAdded', isAdded);
  },
  setEntity({commit}, entity) {
    commit('setEntity', entity);
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/modules/undesirableBehavior/vuex/actions.js